import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-stepper-v2',
  templateUrl: './status-stepper-v2.component.html',
  styleUrls: ['./status-stepper-v2.component.scss'],
})
export class StatusStepperV2Component {
  @Input() stepIndex = 0;

  readonly steps = ['Label purchased', 'In transit', 'Out for delivery', 'Delivered'];
}
